import { conversationQueryKeys } from 'v2/shared/utils/query-key-management'

import { queryClient } from 'v2/configs/rq-setup'
import { type Channels, ConvChannels, type RActiveConversation } from 'v2/types/api/conversations'
import { usePhoneStore } from 'v2/state/phone'
import { getLastChildConversation } from '../../utils'

export const getConversationForTransfer = (conversationId?: string, channel?: Channels) => {
  const { callConversation } = usePhoneStore.getState()
  if (channel === ConvChannels.CALL)
    return {
      // For call channel, we are only concerned about the child channel
      parent: callConversation.callChildConversation,
      child: callConversation.callChildConversation,
    }
  const currentConversation = queryClient
    .getQueryData<RActiveConversation[]>(conversationQueryKeys().active)
    ?.find((c) => c.conversation_number === conversationId)
  return {
    parent: currentConversation,
    child: getLastChildConversation(currentConversation),
  }
}
